import { TableRow } from "@carbon6/c6-frontend-design";
import type { TrainingScheduleOccurrenceView } from "@/api/trainingSchedule";
import { occurrenceStatusLabel, scheduleTimeLabel, shortSha } from "./scheduleFormat";

/**
 * 실행 이력 창의 한 행. occurrence 1건이다.
 *
 * 표시 문자열은 여기서 한 번 만든다(렌더마다 포맷하지 않는다). 행 클릭은 없다. Session 진입은
 * 셀의 링크가 맡고, 행은 사실 한 줄이다.
 */
export class ScheduleOccurrenceTableRow extends TableRow {
  readonly occurrence: TrainingScheduleOccurrenceView;
  readonly scheduledFor: string;
  readonly statusLabel: string;
  readonly sessionId: string | null;
  readonly sha: string;
  readonly error: string;

  constructor(occurrence: TrainingScheduleOccurrenceView) {
    super(null);
    this.occurrence = occurrence;
    this.scheduledFor = scheduleTimeLabel(occurrence.scheduled_for);
    this.statusLabel = occurrenceStatusLabel(occurrence.status);
    this.sessionId = occurrence.session_id ?? null;
    this.sha = shortSha(occurrence.resolved_sha);
    this.error = occurrence.error ?? "";
  }

  getRowId(): string {
    return this.occurrence.id;
  }

  canShow(): boolean {
    return true;
  }

  canSelect(): boolean {
    return false;
  }
}
